import { render, staticRenderFns } from "./Districts_editor.vue?vue&type=template&id=5e2dbea0"
import script from "./Districts_editor.vue?vue&type=script&lang=js"
export * from "./Districts_editor.vue?vue&type=script&lang=js"
import style0 from "./Districts_editor.vue?vue&type=style&index=0&id=5e2dbea0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports